import { mockComponent } from 'bloko/common/setupMockComponents';

export const Context = {};
export default mockComponent('DropTipProvider', null, { withChildren: true });
